<template>
  <div v-if="statuses?.length">
    <div
      v-for="(status, index) in statuses"
      :key="index"
      class="tw-flex tw-items-start tw-gap-5 tw-p-3 tw-rounded-lg tw-text-[#1F2229]"
    >
      <div class="tw-flex tw-items-center tw-gap-2">
        <i :class="status.icon" />
        <span class="tw-font-bold">{{ status.state }}</span>
      </div>
      <div class="tw-flex tw-flex-col">
        <span>{{ status.name }}</span>
        <span
          v-if="status.message && !status.success"
          class="tw-text-sm tw-text-gray-500"
        >{{ status.message }}</span>
      </div>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'PortfolioUploadStatus',
  components: { /* Subcomponents */ },
  props: {
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return { /* Local variables */ };
  },
  computed: {
    ...mapStores(useCheckupStore),
    statuses() {
      return this.checkupStore.files.map(file => {
        const success = ['uploadCompleted', 'uploadValidated'].includes(file.uploadStatus);
        const failure = ['uploadFailed', 'uploadInvalid'].includes(file.uploadStatus);

        let state = 'Uploading';
        if (success) state = 'Completed';
        if (failure) state = 'Failed';

        let icon = 'fas fa-spinner tw-animate-spin tw-text-[#F1583D]';
        if (success) icon = 'fas fa-check tw-text-green-500';
        if (failure) icon = 'fas fa-exclamation-triangle tw-text-[#F1583D]';

        return {
          success,
          failure,
          state,
          icon,
          name: file.name,
          message: file.taskMetadata?.msg,
        };
      });
    },
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


  <style scoped>

  </style>
